declare global {
    interface Window {
        dataLayer: any
    }
}

export const sendDataLayer = (options: any) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ...options });
}